import { useContext } from 'react';

import { Alert, Icons, Typography, Stack } from '@cast/design-system';

import { useHideHpa } from 'features/cluster/workload-optimization/_hooks/permissions/useHideHpa';
import { getWorkloadNativeHpaSpec } from 'features/cluster/workload-optimization/_utils';

import { MetricsSection } from './_components/MetricsSection';
import { WorkloadDetailsContext } from '../../../../_context';
import { NativeHpaMessage } from '../../NativeHpaMessage';

export const NativeHpaSettings = ({
  hideOldWarning = false,
}: {
  hideOldWarning?: boolean;
}) => {
  const { workload } = useContext(WorkloadDetailsContext);
  const nativeHpsSettings = getWorkloadNativeHpaSpec(workload);

  const { hideHpa } = useHideHpa();

  return (
    <Stack
      position="relative"
      overflow="auto"
      pb={16}
      data-testid="native-hpa-settings"
    >
      {!hideHpa && !hideOldWarning && (
        <Alert
          size="sm"
          color="advisory"
          icon={<Icons.Cube size={20} />}
          sx={{ mb: 20 }}
          testId="has-native-hpa-warning"
        >
          <div>
            <Typography variant="P14B">
              Native Horizontal Pod Autoscaler detected
            </Typography>
            <NativeHpaMessage />
          </div>
        </Alert>
      )}

      {nativeHpsSettings && (
        <MetricsSection
          hpaMetrics={nativeHpsSettings.metrics ?? []}
          minReplicas={`${nativeHpsSettings.minReplicas}`}
          maxReplicas={`${nativeHpsSettings.maxReplicas}`}
          behavior={nativeHpsSettings.behavior}
        />
      )}
    </Stack>
  );
};
